<template>
  <div :class="gdqmodeclass">
    <b-navbar 
      sticky 
      toggleable="lg" 
      type="dark"
      class="ml-auto bg-primary pl-2"
      :class="gdqmodeclass"
      variant="primary"
    >
      <div class="col-4 ml-0">
        <b-navbar-brand
          left
          to="/"
          tag="h1"
          class="item-text"
        >
          <Logo />
        </b-navbar-brand>
      </div>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav 
          class="ml-auto"
          :class="gdqmodeclass"
        >
          <b-nav-item-dropdown
            v-if="$store.state.user_id==1"
            right
            style="color: white;"
          >
            <template slot="button-content">
              <span           
                style="color: white;"
              >
              Developer
              </span>
            </template>
            <b-dropdown-item
              href="#"
            >
              <b-link
                to="/i_fields"
              >
                i_fields
              </b-link>
            </b-dropdown-item>                                                                   
          </b-nav-item-dropdown> 
          <b-nav-item-dropdown
            right
            style="color: white;"
          >
            <template slot="button-content">
              <span           
                style="color: white;"
              >
              e-Learning
              </span>
            </template>
            <b-dropdown-item
              href="#"
            >
              <b-link
                to="/courses"
              >
                e-Learning Courses
              </b-link>
            </b-dropdown-item>
            <b-dropdown-item
              href="#"
            >
              <b-link
                to="/elearningmaterials"
              >
                e-Learning Materials
              </b-link>
            </b-dropdown-item>            
            <b-dropdown-item
              href="#"
            >
              <b-link
                to="/elearningquestions"
              >
                e-Learning Questions
              </b-link>
            </b-dropdown-item> 
            <b-dropdown-item
              href="#"
            >
              <b-link
                to="/elearningexams"
              >
                e-Learning Exams
              </b-link>
            </b-dropdown-item>
            <b-dropdown-item
              href="#"
            >
              <b-link
                to="/coursebookings"
              >
                Course Bookings
              </b-link>
            </b-dropdown-item>
            <b-dropdown-item
              href="#"
            >
              <b-link
                to="/examcorrection"
              >
                Exam Correction
              </b-link>
            </b-dropdown-item>            
          </b-nav-item-dropdown>
          <b-nav-item-dropdown
            right
            style="color: white;"
          >
            <template slot="button-content">
              <span           
                style="color: white;"
              >
              Admin
              </span>
            </template>
            <b-dropdown-item
              href="#"
            >
              <b-link
                to="/logintext"
              >
                Login screen text
              </b-link>
            </b-dropdown-item>            
            <b-dropdown-item
              href="#"
            >
              <b-link
                to="/systemmessages"
              >
                System messages
              </b-link>
            </b-dropdown-item>
            <b-dropdown-item
              href="#"
            >
              <b-link
                to="/consultants"
              >
                Consultants
              </b-link>
            </b-dropdown-item>
            <b-dropdown-item
              href="#"
            >
              <b-link
                to="/consultantgroups"
              >
                Consultant Groups
              </b-link>
            </b-dropdown-item>             
            <b-dropdown-item
              href="#"
            >
              <b-link
                to="/invoicereport"
              >
                Invoices
              </b-link>
            </b-dropdown-item>
            <b-dropdown-item
              href="#"
            >
              <b-link
                to="/companies"
              >
                Companies
              </b-link>
            </b-dropdown-item>
            <b-dropdown-item
              href="#"
            >
              <b-link
                to="/partners"
              >
                Partners
              </b-link>
            </b-dropdown-item>
            <b-dropdown-item
              href="#"
            >
              <b-link
                to="/faq"
              >
                FAQ
              </b-link>
            </b-dropdown-item>
            <b-dropdown-item
              href="#"
            >
              <b-link
                to="/faqcategories"
              >
                FAQ Categories
              </b-link>
            </b-dropdown-item> 
            <b-dropdown-item
              href="#"
            >
              <b-link
                to="/consentresearch"
              >
                Consent to Research
              </b-link>
            </b-dropdown-item> 
            <b-dropdown-item
              href="#"
            >
              <b-link
                to="/consent"
              >
                Consent to Personal Information
              </b-link>
            </b-dropdown-item>                                     
            <b-dropdown-item
              href="#"
            >
              <b-link
                to="/utilities"
              >
                Utilities
              </b-link>
            </b-dropdown-item>
            <b-dropdown-item
              href="#"
            >
              <b-link
                to="/screens"
              >
                Screens
              </b-link>
            </b-dropdown-item>  
            <b-dropdown-item
              href="#"
            >
              <b-link
                to="/screenelements"
              >
                Screen elements
              </b-link>
            </b-dropdown-item>                                                        
          </b-nav-item-dropdown>
          <b-nav-item-dropdown
            right
            style="color: white;"
          >
            <template slot="button-content">
              <span           
                style="color: white;"
              >
              Settings
              </span>
            </template>
            <b-dropdown-item
              href="#"
            >
              <b-link
                to="/mailsettings"
              >
                Mail Settings
              </b-link>
            </b-dropdown-item>
            <b-dropdown-item
              href="#"
            >
              <b-link
                to="/gdqsettings"
              >
                GDQ Settings
              </b-link>
            </b-dropdown-item>
            <b-dropdown-item
              href="#"
            >
              <b-link
                to="/gdqshortsettings"
              >
                GDQ Short Settings
              </b-link>
            </b-dropdown-item>
            <b-dropdown-item
              href="#"
            >
              <b-link
                to="/oscsettings"
              >
                OSC Settings
              </b-link>
            </b-dropdown-item>
            <b-dropdown-item
              href="#"
            >
              <b-link
                to="/aggregatedreportsettings"
              >
                Aggregated Reports Settings
              </b-link>
            </b-dropdown-item>
            <b-dropdown-item
              href="#"
            >
              <b-link
                key="countries"
                to="/countries"
              >
                Countries
              </b-link>
            </b-dropdown-item> 
            <b-dropdown-item
              href="#"
            >
              <b-link
                key="languages"
                to="/languages"
              >
                Languages
              </b-link>
            </b-dropdown-item> 
            <b-dropdown-item
              href="#"
            >
              <b-link
                key="supportissues"
                to="/supportissues"
              >
                Support issues list
              </b-link>
            </b-dropdown-item>                                                                      
          </b-nav-item-dropdown>
          <!-- <b-nav-item href="#">
            <b-link
            style="color: white"
              to="/planner"
            >
              Planner
            </b-link>
          </b-nav-item> -->
          <b-nav-item href="#">
            <span
              @click="logout"
            >Log out</span>
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
      <b-checkbox
        v-model="anon"
        @change="toggleanon"
      >
        <span style="color: white;">Anon.</span>
      </b-checkbox>      
    </b-navbar>
  </div>  
</template>
<script>
import { config } from '../../config'
import Logo from './Logo.vue';
export default {
  components: {
    Logo
  },
  data() {
    return {
      anon: this.$store.state.anon,
      gdqmodeclass: (config.mode == 'live') ? 'bg-primary' : config.mode == 'stage' ? 'bg-secondary' : 'bg-danger',      
      search: '',
    }
  },
  methods: {
    toggleanon(e) {
      this.$store.dispatch('toggleanon')
    },
    logout: function() {
      this.$store
        .dispatch("logout",{})
        .then(() => this.$router.push("/login"))
        // eslint-disable-next-line
        .catch(err => console.log(err));
    }
  }
}    
</script>
<style scoped>
a.nav-link {
  color: white !important;
}
a.nav-link.dropdown-toggle {
  color: white !important;
}
</style>

